import TempleIcon from './Temple';
import OutlinedHelp from './OutlinedHelp';
import Logo from './Logo';
import Mail from './Mail';
import Lock from './Lock';
import CheckMark from './CheckMark';
import Star from './Star';
import ArrowDown from './ArrowDown';
import ArrowUp from './ArrowUp';
import Shopify from './Shopify';
import User from './User';
import Store from './Store';
import PayPal from './PayPal';
import Stripe from './Stripe';
import Calendar from './Calendar';
import Check from './Check';
import ComingSoon from './ComingSoon';
import Card from './Card';
import Chart from './Chart';
import Chat from './Chat';
import Dashboard from './Dashboard';
import Disputes from './Disputes';
import Document from './Document';
import File from './File';
import Layout from './Layout';
import Notification from './Notification';
import Repeat from './Repeat';
import Settings from './Settings';
import Sync from './Sync';
import ArrowRight from './ArrowRight';
import ArrowLeft from './ArrowLeft';
import TrackingInfo from './TrackingInfo';
import Attention from './Attention';
import Offer from './Offer';
import ChevronRight from './ChevronRight';
import ExclamationMark from './ExclamationMark';
import PayPalWithText from './PayPalWithText';
import StripeWithText from './StripeWithText';
import List from './List';
import ArrowForward from './ArrowForward';
import ArrowBack from './ArrowBack';
import Upload from './Upload';
import Filter from './Filter';
import Avatar from './Avatar';
import Send from './Send';
import CardExpress from './CardExpress';
import Fail from './Fail';
import Success from './Success';
import Ecommerce from './Ecommerce';
import Dropshipping from './Dropshipping';
import PhysicalSubscription from './PhysicalSubscription';
import DigitalSubscription from './DigitalSubscription';
import Header from './Header';
import Paragraph from './Paragraph';
import Email from './Email';
import Screenshot from './Screenshot';
import Image from './Image';
import Verification from './Verification';
import PageBreak from './PageBreak';
import Package from './Package';
import Cart from './Cart';
import More from './More';
import PayPalWhite from './PayPalWhite';
import PayPalSync from './PayPalSync';
import Note from './Note';
import Queue from './Queue';
import HeavyCheck from './HeavyCheck';
import ShopifyWithText from './ShopifyWithText';
import Add from './Add';

const icons = {
  avatar: Avatar,
  add: Add,
  card: Card,
  chart: Chart,
  chat: Chat,
  dashboard: Dashboard,
  disputes: Disputes,
  document: Document,
  file: File,
  layout: Layout,
  notification: Notification,
  repeat: Repeat,
  settings: Settings,
  sync: Sync,
  temple: TempleIcon,
  'outlined-help': OutlinedHelp,
  logo: Logo,
  mail: Mail,
  lock: Lock,
  'check-mark': CheckMark,
  star: Star,
  'arrow-down': ArrowDown,
  'arrow-up': ArrowUp,
  shopify: Shopify,
  user: User,
  store: Store,
  paypal: PayPal,
  stripe: Stripe,
  check: Check,
  'coming-soon': ComingSoon,
  'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft,
  'tracking-info': TrackingInfo,
  attention: Attention,
  offer: Offer,
  'chevron-right': ChevronRight,
  'exclamation-mark': ExclamationMark,
  'stripe-text': StripeWithText,
  'paypal-text': PayPalWithText,
  list: List,
  'arrow-forward': ArrowForward,
  'arrow-back': ArrowBack,
  upload: Upload,
  filter: Filter,
  calendar: Calendar,
  send: Send,
  'card-express': CardExpress,
  success: Success,
  fail: Fail,
  ecommerce: Ecommerce,
  dropshipping: Dropshipping,
  'physical-subscription': PhysicalSubscription,
  'digital-subscription': DigitalSubscription,
  header: Header,
  paragraph: Paragraph,
  email: Email,
  screenshot: Screenshot,
  image: Image,
  verification: Verification,
  'page-break': PageBreak,
  package: Package,
  cart: Cart,
  more: More,
  'paypal-white': PayPalWhite,
  'paypal-sync': PayPalSync,
  note: Note,
  queue: Queue,
  'heavy-check': HeavyCheck,
  'shopify-text': ShopifyWithText,
};

export default icons;
